import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import CustomButton from "../../assets/buttons/CustomButton";
import {
  Buttons,
  GLOBAL_IMAGES,
  SIDEBAR as SIDEBAR_ICONS,
} from "../../assets/asset";

import year1 from "../../assets/components/lessonDashboard/Year1.webp";
import year2 from "../../assets/components/lessonDashboard/Year2.webp";
import year3 from "../../assets/components/lessonDashboard/Year3.webp";
import year4 from "../../assets/components/lessonDashboard/Year4.webp";
import year5 from "../../assets/components/lessonDashboard/Year5.webp";
import year6 from "../../assets/components/lessonDashboard/Year6.webp";
import year7 from "../../assets/components/lessonDashboard/Year7.webp";
import year8 from "../../assets/components/lessonDashboard/Year8.webp";
import year9 from "../../assets/components/lessonDashboard/Year9.webp";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

const decideYearImage = (yearNumber) => {
  switch (yearNumber) {
    case 0:
      return year1;
    case 1:
      return year2;
    case 2:
      return year1;
    case 3:
      return year2;
    case 4:
      return year3;
    case 5:
      return year4;
    case 6:
      return year5;
    case 7:
      return year6;
    case 8:
      return year7;
    case 9:
      return year8;
    case 10:
      return year9;
    default:
      return year1;
  }
};

const QuestionSidebar = ({
  onAudioPlay,
  SIDEBAR = SIDEBAR_ICONS,
  videoUrl,
  onWhiteboardToggle,
  onVideoModalToggle,
  isVideo = true,
  styles,
}) => {
  const { currentYear } = useSelector((s) => s.profile);
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(true);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [audioBlocked, setAudioBlocked] = useState(false);

  const audioRef = useRef(null);
  const yearBackground = decideYearImage(currentYear?.fields?.yearId);

  useEffect(() => {
    if (!showVideoModal) return;

    const handleKeyDown = (e) => {
      if (e.code === "Space") {
        e.preventDefault(); // stop scroll / bubbling
        const videoEl = document.querySelector("video");
        if (videoEl) {
          if (videoEl.paused) {
            videoEl.play();
          } else {
            videoEl.pause();
          }
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showVideoModal]);

  const handleAudioClick = () => {
    onAudioPlay?.();
    setAudioBlocked(false);
    setTimeout(() => {
      if (!audioRef.current?.played) {
        setAudioBlocked(true);
      }
    }, 1000);
  };

  const toggleSidebar = () => setIsExpanded((prev) => !prev);

  const handleVideoClick = () => {
    setShowVideoModal(true);
    setIsVideoLoaded(false);
    onVideoModalToggle?.(true);
  };

  const handleVideoLoad = () => setIsVideoLoaded(true);

  const handleVideoEnd = () => {
    setShowVideoModal(false);
    onVideoModalToggle?.(false);
  };

  const handleCloseVideo = () => {
    setShowVideoModal(false);
    onVideoModalToggle?.(false);
    // navigate(-1);
  };

  useEffect(() => {
    window.addEventListener("popstate", handleCloseVideo);
    return () => {
      window.removeEventListener("popstate", handleCloseVideo);
    };
  }, []);

  const isVideoUrlValid = videoUrl && videoUrl.trim() !== "";

  return (
    <>
      <div style={styles?.container}>
        <div
          className={`
            bg-white w-[4rem] rounded-r-[2rem] 
            flex flex-col items-center overflow-hidden
            transition-all duration-500 ease-in-out
            ${isExpanded ? "space-y-4 py-3" : "space-y-0 py-0"}
          `}
          style={{
            height: isExpanded ? styles?.height : "50px",
          }}
        >
          {/* Toggle Button */}
          <button
            onClick={toggleSidebar}
            className="p-2 hover:bg-gray-100/50 rounded-full transition-transform duration-300"
          >
            <img
              src={isExpanded ? SIDEBAR.colapse : SIDEBAR.expend}
              alt={isExpanded ? "Collapse" : "Expand"}
              className={`h-8 w-8 transform transition-transform duration-300 ${
                isExpanded ? "rotate-180" : "rotate-0"
              }`}
            />
          </button>

          {/* Action Buttons */}
          <div
            className={`
              flex flex-col items-center space-y-4 
              transform transition-all duration-500 ease-in-out
              ${
                isExpanded
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 -translate-y-5 pointer-events-none"
              }
            `}
          >
            {/* {onAudioPlay && (
              <button
                onClick={handleAudioClick}
                className="p-2 rounded-full hover:bg-gray-100/50 transition-transform duration-300 hover:scale-105"
              >
                <img src={SIDEBAR.audio} alt="Audio" className="h-8 w-8" />
              </button>
            )} */}

            {isVideo && isVideoUrlValid && (
              <button
                onClick={handleVideoClick}
                className="p-2 hover:bg-gray-100/50 rounded-full transition-transform duration-300 hover:scale-105"
              >
                <img src={SIDEBAR.video} alt="Video" className="h-8 w-8" />
              </button>
            )}

            <button
              onClick={onWhiteboardToggle}
              className="p-2 hover:bg-gray-100/50 rounded-full transition-transform duration-300 hover:scale-105"
            >
              <img src={SIDEBAR.board} alt="Whiteboard" className="h-8 w-8" />
            </button>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {showVideoModal && (
        <div
          className="fixed top-0 left-0 bg-black/70 bg-blend-multiply h-screen w-screen flex flex-col items-center justify-center z-[9999]"
          style={{
            // backgroundImage: `url(${yearBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="relative w-[75%]  h-auto bg-transparent">
            <div className="w-full h-full  rounded-lg overflow-hidden">
              {!isVideoLoaded && (
                <div className="w-auto h-[80vh] min-h-[400px] max-h-[80vh] bg-gray-200 animate-pulse rounded" />
              )}
              <video
                className={`w-auto mx-auto h-[80vh] min-h-[400px] ${
                  !isVideoLoaded ? "hidden" : ""
                }`}
                src={videoUrl}
                controls
                autoPlay
                onEnded={handleVideoEnd}
                onLoadedData={handleVideoLoad}
              />
              <img
                src={Buttons.cross}
                className="absolute size-12 cursor-pointer top-10 right-2"
                onClick={handleCloseVideo}
              />
            </div>
          </div>

          <div className="w-[75%]  flex justify-end mt-6 z-[10000]">
            <CustomButton
              text="Continue"
              onClick={handleCloseVideo}
              type="correct"
              disabled={false}
              isIcon={true}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionSidebar;
